<template>
  <div>
    <div @click="uploadFileDialog = true" v-if="btn !== false">
      <slot />
    </div>
    <v-dialog
      persistent
      width="600"
      v-model="uploadFileDialog"
      transition="dialog-bottom-transition"
      @keydown.esc="closeFileDialog"
    >
      <v-card>
        <v-toolbar dark color="primary" max-height="60">
          <h3>{{ $i18n.t(label) }}</h3>
          <v-spacer/>
          <v-btn icon dark @click="closeFileDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="8" md="8" lg="6"
              ><v-file-input
                chips
                :label="$i18n.t('Attachment')"
                @change="handleFileUpload()"
                v-model="file_upload"
              ></v-file-input
            ></v-col>
            <v-col cols="12" sm="4" md="2" lg="1"
              ><v-btn
                color="green"
                class="mr-0"
                v-on:click="uploadFile()"
                :loading="up_loading"
              >
                <h3>{{ $i18n.t("Upload") }}</h3>
              </v-btn></v-col
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPostForm } from "@/store/common/module/apis";

@Component({
  name: "UploadFileDialog",
  components: {},
  props: {
    showDialog: {
      default: false,
    },
    requestURL: {
      default: null,
    },
    btn: {
      default: null,
    },
    label: {
      default: "Upload Attachment",
    },
  },
})
export default class UploadFileDialog extends Vue {
  uploadFileDialog = false;
  file_upload = null;
  up_loading = null;

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.uploadFileDialog = val;
  }

  closeFileDialog() {
    this.uploadFileDialog = false;
    this.$emit("select", null);
  }

  handleFileUpload(files) {
    if (files) {
      this.file_upload = files[0];
    }
  }

  async uploadFile() {
    if (this.requestURL) {
      try {
        common.setLoading(true);
        const formData = new FormData();
        if (this.file_upload) {
          formData.append("file", this.file_upload);
        }
        this.up_loading = true;
        await doPostForm(this.requestURL, formData);
        this.up_loading = null;
        common.setLoading(false);
        this.$emit("closeDialog", true);
        this.closeFileDialog();
      } catch (e) {
        this.up_loading = null;
        common.setError(e.message);
        common.setLoading(false);
      }
    }
  }
}
</script>
